import ProjectOverviewQuery from './ProjectOverviewQuery';
import { selectFromProjectPaginatedDto } from '../../models';

export default selectFromProjectPaginatedDto()
  .hasNextPage
  .edges(b => b.node(ProjectOverviewQuery))
  .toString();
